import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listInventories } from '../Api'

export default generateApiAction({
  baseType: Types.INVENTORIES.LIST,
  api: listInventories,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/inventories/ListAction.js